import { render, staticRenderFns } from "./FollowUpNote.vue?vue&type=template&id=de6cc9a8&scoped=true"
import script from "./FollowUpNote.vue?vue&type=script&lang=js"
export * from "./FollowUpNote.vue?vue&type=script&lang=js"
import style0 from "./FollowUpNote.vue?vue&type=style&index=0&id=de6cc9a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6cc9a8",
  null
  
)

export default component.exports